"use strict";


/* functions */
/* global noRecordsCreated */

let isRecording = false;
let feedbackSended = true;
let redirectUrl = "";


window.addEventListener('beforeunload', function (e) {
  //console.log("servuse: " + document.getElementById("video_screenshot").srcObject);
  // Cancel the event

  //console.log(isRecording);
  //console.log(feedbackSended);

  if (isRecording || !feedbackSended) {
    /* ( document.getElementById("feedback_txt_msg") !== null && document.getElementById("feedback_txt_msg").value.length !== 0 ) ||
     ( document.getElementById("video_screen") !== null && document.getElementById("video_screen").src !== "" ) ||
     ( document.getElementById("video_record_screen") !== null && document.getElementById("video_record_screen").src !== "" )) {*/

    e.preventDefault();
    e.returnValue = '';
  }
});

let pressedKeys = {};
//window.onkeyup = function(e) { console.log(e.key); pressedKeys[e.keyCode] = false; }
//window.onkeydown = function(e) { console.log(e.key); pressedKeys[e.keyCode] = true; }
window.addEventListener('keyup', function (e) {
  pressedKeys[e.key] = false;
});
window.addEventListener('keydown', function (e) {
  pressedKeys[e.key] = true;
});


function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  let n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  let arr2 = null;
  if (len == null || len > arr.length) len = arr.length;
  for (let i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

if ($('.menu__block-sub')) {
  let menuItem = $('.menu__block-sub').closest('.menu__block-item');
  menuItem.on('click', function () {
    $('.menu__block-sub').removeClass('toggle');
    $(this).find('.menu__block-sub').addClass('toggle');
    $('.menu__block-sub').not('.toggle').slideUp();
    $(this).find('.toggle').slideToggle();
  });
}

$('.menu__colormode').on('click', function () {
  $('body').toggleClass('dark');

  requestSetNightState($('body').hasClass('dark'));
});
$('.menu__displaymode').on('click', function () {
  $('.menu').toggleClass('min');
  $('.board').toggleClass('min');

  requestCloseMenuAjax($('.menu').hasClass('min'));
});

$('.menu__helpmpde').on('click', function () {
  let u = document.getElementById("url_input").value;
  showHelpTour(u);
});

$('body').on('mouseover', '.overview-item p', function () {
  let child = $(this).children().length;
  let children = $(this).children();

  /* this part is to prevent hover effect at name-column */
  if (child > 3) {
    if (children[3].classList.contains("overview-item__work_areas")) {
      return;
    }
  }
  /* *** */

  if (child === 0) {
    $('.overview-item p').removeClass('hover hover-item');
    $(this).addClass('hover');
  }

  if (child >= 1) {
    $('.overview-item p').removeClass('hover-item hover');
    $(this).addClass('hover-item');
  }
});


$('body').on('click', '.open_shift', function (event) {
  if (event.target.classList.contains("clickable")) {
    //$('body').css('overflow', 'auto');

    let uid = $(this).children('input').first().val();
    let shift_date = $(this).children('input').eq(1).val();
    let bg = $(this).css('background-color');
    $(this).css('background', 'red'); //change second element background
    let that = this;
    setTimeout(function () {
      $(that).css('background', bg); // change it back after ...
    }, 1000); // waiting one second

    setUId(uid);
    requestLoadDayDienstDataEmp(shift_date);
  }
});

$('body').on('click', '.overview-item p', function (event) {
  //console.log("CLICK!!");

  if ($(this).hasClass("open_dienste")) {

    if (event.target.className === "item-basic") {
      if (event.target.parentNode.classList.contains("clickable")) {
        showOpenServicePrompt(event.target.childNodes[0].textContent, event.target.children[1].value, event.target.children[0].value,
          event.target.children[2].value, event.target.children[5].value, event.target.children[3].value, event.target.children[4].value, "edit");
      }
    } else if (event.target.className !== "showElement") {
      if (event.target.classList.contains("clickable")) {
        showOpenServicePrompt("", "", "", "", event.target.children[0].value, "", "", "new");
      }
    }
  } else if ($(this).hasClass("event")) {

    if (this.getElementsByTagName("input")[0] !== undefined) {
      if (this.getElementsByTagName("input")[0].parentNode.classList.contains("clickable")) {
        showEventPrompt(this.getElementsByTagName("input")[0].value, this.getElementsByTagName("span")[0].textContent);
      }
    } else {
      if(typeof noRecordsCreated === "function")
        noRecordsCreated();
    }
    if (this.getElementsByTagName("input")[0] !== undefined && this.getElementsByTagName("input")[0].parentNode.classList.contains("clickable")) {
      setCurrentSpanText(this.getElementsByTagName("span")[0]);
    }
  } else {
    //console.log("else");
    if (event.target.classList.contains("clickable")) {
      //console.log("clickable");
      //$('body').css('overflow', 'auto');
      let selected_work_area = 0;

      if (event.target.nodeName === "SPAN" && event.target.querySelector('input') !== null) {
        selected_work_area = event.target.querySelector('input').value;
      }

      let uid = $(this).children('input').first().val();
      let shift_date = $(this).children('input').eq(1).val();

      setUId(uid);

      if (window.location.pathname === "/ShiftPlan") {
        if (event.target.classList.contains("workareamanager")) {
          document.getElementsByTagName("body")[0].style.overflowY = "hidden";
          requestLoadDayDienstData(uid, shift_date, selected_work_area);
        } else
          requestLoadDayDienstDataEmp(shift_date);
      } else {
        document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        requestLoadDayDienstData(uid, shift_date, selected_work_area);
      }
    }
  }
});

$('body').on('mouseover', '.overview-item:nth-child(2) p span', function () {

  if (!this.classList.contains("showElement")) {
    let str = $(this).text();
    let endtime = ($(this).children('input').first().val());
    $('.hover-content').remove();
    $('<div class="hover-content"/>').text(str + '- ' + endtime).appendTo($(this));
  }
});

$('body').on('mouseleave', '.overview-item:nth-child(2) p span', function () {
  $('.hover-content').remove();
});
let spanBlock = $('.overview-item:nth-child(2) p');
spanBlock.each(function (index) {
  let total = $(this).children('span').length;
  let last;
  $(this).children('span').each(function (elem) {
    if (elem > 7) {
      let container = $(this).closest('p');
      container.addClass('withHideElement');
      if (elem === total - 1) {
        last = elem - 6;
        $('<span class="showElement" onclick="showMore($(this))" style="display: block" />').text('+' + last).appendTo('.field-' + index);
      }
    }
  });
});

function showMore(index) {
  index.hide();
  index.closest('p').toggleClass('withHideElement');
}

$("input, textarea").focus(function (event) {
  $(this).closest(".form-group").addClass("styled").addClass("focus");
}).blur(function () {
  if ($(this).attr('type') !== 'date') {
    $(this).closest(".form-group ").removeClass("focus");

    if (!$(this).val()) {
      $(this).closest(".form-group ").removeClass("styled");
    }
  }
}).each(function (i) {
  if ($(this).val().length >= 1) {
    $(this).closest(".form-group").addClass("styled");
  } else if ($(this).val().length < 1) {
    $(this).closest(".form-group").removeClass("styled");
  }
});

function refreshInputs() {
  $("input, textarea").each(function (i) {
    if ($(this).val().length >= 1) {
      $(this).closest(".form-group").addClass("styled");
    } else if ($(this).val().length < 1) {
      $(this).closest(".form-group").removeClass("styled");
    }
  });
}

$('body').on('click', '.modal-close', function () {
  //$('body').css('overflow', 'auto');
  $('.modal').fadeOut("fast");
});
$(document).on('keyup', function (e) {
  if (e.key === "Escape") {
    document.getElementsByTagName("body")[0].style.removeProperty("overflow-y");
    $('.modal').fadeOut("fast");

    if ($('#modal_day_dienst:visible').length === 1) {
      if (setModalToDefault instanceof Function)
        setModalToDefault();
    }
  }

  // global fetch of "Enter" on Prompt
  // Enter Button has to have data-btn="enter"
  if (e.key === "Enter") {
    // noinspection JSJQueryEfficiency
    $('.modal:visible').each(function () {
      let submitBtn = $(this).find("[data-btn=enter]");
      if (submitBtn !== undefined)
        submitBtn.click();
    });
  }
}).on('click', function (e) {
  if (e.target !== null && e.target.parentNode !== null && e.target.classList !== undefined && e.target.parentNode.classList !== undefined) {
    if (!(e.target.classList.contains("no-closeDropDown")) && !(e.target.parentNode.classList.contains("no-closeDropDown"))) {
      closeAllDropDowns();
      e.stopImmediatePropagation();
    }
  }
});

function closeAllDropDowns() {
  let el = document.getElementsByClassName("closeDropDown");//document.getElementById("stamp_desktop_element");
  for (let element of el) {
    let open_div = $(element).find($('.' + $(element).attr('data-open')));

    // close Web-Checkin
    if (!($("#" + element.id).is(":hidden"))) {
      $('#' + element.id).slideToggle();
    }
  }
}


$('.settings-bar').on('click', function () {
  $('.settings-bar').removeClass('active');
  $(this).addClass('active');
  let block = $(this).attr('data-class');
  $('.settings-page__right').hide();
  $('.' + block).show();
});
$('.settings-bar2').on('click', function () {
  $('.settings-bar2').removeClass('active');
  $(this).addClass('active');
  let block = $(this).attr('data-class');
  $('.settings-page2__right').hide();
  $('.' + block).show();
});

$('.settings-open').on('click', settingsOpen);

function settingsOpen(e) {
  $('.drop-setting').hide();
  $(this).find($('.' + $(this).attr('data-open'))).slideToggle();
  //$(this).find($('.' + $(this).attr('data-open'))).addClass('closeDropDown');
  //e.stopPropagation(); // stop to not immediate close it again because of listener on dom for close
  //e.preventDefault();
  e.stopImmediatePropagation();
}

$('.header-time__drop').on('click', function (e) {
  //console.log(e.target.querySelector('input'));
  //console.log(e.target.querySelector('input').value);
  e.stopImmediatePropagation();
});

$('.filter-clear').on('click', function () {
  $(this).closest('.filter').find('input').prop('checked', false);
  $(this).closest('.filter').slideUp();
  $('.settings-filter').removeClass('active');
});
$('.filter-done').on('click', function () {
  let allInput = $(this).closest('.filter').find('input');
  let active = 0;
  allInput.each(function () {
    if ($(this).prop('checked') >= 1) {
      active++;
    }

    if (active >= 1) {
      $('.settings-filter').addClass('active');
    } else {
      $('.settings-filter').removeClass('active');
    }
  });
  $(this).closest('.filter').slideUp();
});
$('.menu-btn').on('click', function () {
  $('.menu').toggleClass('show');
}); // dashboard

$('.dashboard-block__top span').on('click', function () {
  $(this).closest('.dashboard-block').toggleClass('minimize');
  $(this).closest('.dashboard-block').find('.dashboard-block__content').slideToggle();
}); //Mitarbeiteradministration

$('.administration-search').on('keydown', function () {
  let val = $(this).val().length;

  if (val !== 1) {
    $('.search-clean').css('display', 'flex');
    $('.settings-search>svg:first-child').css('display', 'none');
    $('.search-clean').on('click', function () {
      $('.administration-search').val('');
      $('.settings-search>svg:first-child').css('display', 'none');
    });
  } else {
    $('.settings-search>svg:first-child').css('display', 'flex');
    $('.search-clean').css('display', 'none');
  }
}); //open modal data-attribute

$('.open-modal').on('click', function () {
  $('.' + $(this).attr('data-modal')).fadeIn("fast");
  $('body').css('overflow', 'hidden');
}); //file input load image view

$(function () {
  let imagesPreview = function imagesPreview(input, placeToInsertImagePreview) {
    if (input.files) {
      let filesAmount = input.files.length;

      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();
        reader.onload = async function (event) {
          const result = await resizeBase64Image(event.target.result);

          requestSetProfileImage(result, placeToInsertImagePreview);
        };

        reader.readAsDataURL(input.files[i]);
      }
    }
  };


  let uploadLocationImage = function uploadLocationImage(input, placeToInsertImagePreview) {
    if (input.files) {
      let filesAmount = input.files.length;

      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();
        reader.onload = async function (event) {
          const result = await resizeBase64Image(event.target.result);

          requestSetLocationImage(result, placeToInsertImagePreview);
        };

        reader.readAsDataURL(input.files[i]);
      }
    }
  };

  $('#user-image-upload').on('change', function () {
    imagesPreview(this, '.new-employee__img-img');
  });
  $('#change-logo').on('change', function () {
    imagesPreview(this, '.dashboard-location__img');
  });
  $('#upload-location-img').on('change', function () {
    uploadLocationImage(this, '.dashboard-location__img');
  });
  $('#change-profile-image').on('change', function () {
    imagesPreview(this, '.dashboard-location__img');
  });

  const resizeBase64Image = (base64Str, maxWidth = 200, maxHeight = 150) => {
    return new Promise((resolve) => {
      let img = new Image()
      img.src = base64Str
      img.onload = () => {
        let canvas = document.createElement('canvas')
        const MAX_WIDTH = maxWidth
        const MAX_HEIGHT = maxHeight
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL())
      }
    })
  }
}); //drop file


$('.load-doc').on('dragover', function (e) {
  e.preventDefault();
  e.stopPropagation();
});
$('.load-doc').on('dragenter', function (e) {
  e.preventDefault();
  e.stopPropagation();
});
$('.load-doc').on('drop', function (e) {
  if (e.originalEvent.dataTransfer) {
    if (e.originalEvent.dataTransfer.files.length) {
      e.preventDefault();
      e.stopPropagation();
      upload(e.originalEvent.dataTransfer.files);
    }
  }
});

function upload(files) {
  if ($('.new-employee__info-loc').length > 0) {
    let container = $('<div>').appendTo('.new-employee__info-loc');
    container.addClass('upload-file');
    let text = $('<p>').appendTo(container);
    text.text(files[0].name);
    let remove = $('<div>').appendTo(container);
    remove.attr('onclick', 'removeFile(this)');
    remove.attr('class', 'remove-file');
  }

  if ($('.dashboard-user__upload').length > 0) {
    let _container = $('<div>').insertBefore('.load-doc');

    _container.addClass('upload-file');

    let _text = $('<p>').appendTo(_container);

    _text.text(files[0].name);

    let leftBlock = $('<div>').appendTo(_container);
    let download = $('<div>').appendTo(leftBlock);
    download.attr('onclick', 'downloadFile(this)');
    download.attr('class', 'download-file');

    let _remove = $('<div>').appendTo(leftBlock);

    _remove.attr('onclick', 'removeFile(this)');

    _remove.attr('class', 'remove-file');
  }
}

$(function () {
  let filePreview = function filePreview(input, contaniner) {
    if (input.files) {
      let filesAmount = input.files.length;

      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();

        reader.onload = function (event) {
          if ($('.new-employee__info-loc').length > 0) {
            let container = $('<div>').appendTo(contaniner);
            container.addClass('upload-file');
            let text = $('<p>').appendTo(container);
            text.text(input.files[0].name);
            let remove = $('<div>').appendTo(container);
            remove.attr('onclick', 'removeFile(this)');
            remove.attr('class', 'remove-file');
          }

          if ($('.dashboard-user__upload').length > 0) {
            let _container2 = $('<div>').insertBefore(contaniner);

            _container2.addClass('upload-file');

            let _text2 = $('<p>').appendTo(_container2);

            _text2.text(input.files[0].name);

            let leftBlock = $('<div>').appendTo(_container2);
            let download = $('<div>').appendTo(leftBlock);
            download.attr('onclick', 'downloadFile(this)');
            download.attr('class', 'download-file');

            let _remove2 = $('<div>').appendTo(leftBlock);

            _remove2.attr('onclick', 'removeFile(this)');

            _remove2.attr('class', 'remove-file');
          }
        };

        reader.readAsDataURL(input.files[i]);
      }
    }
  };

  let filePreviewLocation = function filePreviewLocation(input, contaniner) {
    if (input.files) {
      let filesAmount = input.files.length;

      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();

        reader.onload = function (event) {
          let container = $('.upload-file').addClass('loaded').find('p');
          container.text(input.files[0].name);
        };

        reader.readAsDataURL(input.files[i]);
      }
    }
  };

  $('.load-doc input').on('change', function () {
    if ($('.new-employee__info-loc')) {
      filePreview(this, '.new-employee__info-loc');
    }

    if ($('.dashboard-user__upload')) {
      filePreview(this, '.load-doc');
    }
  });
  $('.dashboard-employeesnew-file input').on('change', function () {
    filePreviewLocation(this, '.dashboard-employeesnew-file');
  });
});
$('.stamp-times .administration-item p:last-child').on('click', function () {
  $(this).find('.settings-open').slideToggle();
});
$('.status').on('click', function () {
  // $('.status-drop').hide();
  $(this).find('.status-drop').slideToggle();
});

function removeFile(elem) {
  $(elem).closest('.upload-file').remove();
}

if ($('.new-employee').length) {
  // filter an array of options against an input string
  // returns an array of options that begin with the filter string, case-independent
  let filterOptions = function filterOptions() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let filter = arguments.length > 1 ? arguments[1] : undefined;
    let exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return options.filter(function (option) {
      let matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
      return matches && exclude.indexOf(option) < 0;
    });
  }; // return an array of exact option name matches from a comma-separated string


  let findMatches = function findMatches(options, search) {
    let names = search.split(',');
    return names.map(function (name) {
      let match = options.filter(function (option) {
        return name.trim().toLowerCase() === option.toLowerCase();
      });
      return match.length > 0 ? match[0] : null;
    }).filter(function (option) {
      return option !== null;
    });
  }; // return combobox action from key press


  let getActionFromKey = function getActionFromKey(key, menuOpen) {
    // handle opening when closed
    if (!menuOpen && key === Keys.Down) {
      return MenuActions.Open;
    } // handle keys when open


    if (key === Keys.Down) {
      return MenuActions.Next;
    } else if (key === Keys.Up) {
      return MenuActions.Previous;
    } else if (key === Keys.Home) {
      return MenuActions.First;
    } else if (key === Keys.End) {
      return MenuActions.Last;
    } else if (key === Keys.Escape) {
      return MenuActions.Close;
    } else if (key === Keys.Enter) {
      return MenuActions.CloseSelect;
    } else if (key === Keys.Backspace || key === Keys.Clear || key.length === 1) {
      return MenuActions.Type;
    }
  }; // get index of option that matches a string


  let getIndexByLetter = function getIndexByLetter(options, filter) {
    let firstMatch = filterOptions(options, filter)[0];
    return firstMatch ? options.indexOf(firstMatch) : -1;
  }; // get updated option index


  let getUpdatedIndex = function getUpdatedIndex(current, max, action) {
    switch (action) {
      case MenuActions.First:
        return 0;

      case MenuActions.Last:
        return max;

      case MenuActions.Previous:
        return Math.max(0, current - 1);

      case MenuActions.Next:
        return Math.min(max, current + 1);

      default:
        return current;
    }
  }; // check if an element is currently scrollable


  let isScrollable = function isScrollable(element) {
    return element && element.clientHeight < element.scrollHeight;
  }; // ensure given child element is within the parent's visible scroll area


  let maintainScrollVisibility = function maintainScrollVisibility(activeElement, scrollParent) {
    let offsetHeight = activeElement.offsetHeight,
      offsetTop = activeElement.offsetTop;
    let parentOffsetHeight = scrollParent.offsetHeight,
      scrollTop = scrollParent.scrollTop;
    let isAbove = offsetTop < scrollTop;
    let isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

    if (isAbove) {
      scrollParent.scrollTo(0, offsetTop);
    } else if (isBelow) {
      scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
  };
  /*
   * Multiselect Combobox w/ Buttons code
   */


  // options for all examples
  let options = ['Counter', 'Services', 'Services1', 'Services2', 'Services3', 'Services4', 'Services5'];
  /*
   * Helper constants and functions
   */
  // make it easier for ourselves by putting some values in objects
  // in TypeScript, these would be enums

  let Keys = {
    Backspace: 'Backspace',
    Clear: 'Clear',
    Down: 'ArrowDown',
    End: 'End',
    Enter: 'Enter',
    Escape: 'Escape',
    Home: 'Home',
    Left: 'ArrowLeft',
    PageDown: 'PageDown',
    PageUp: 'PageUp',
    Right: 'ArrowRight',
    Space: ' ',
    Tab: 'Tab',
    Up: 'ArrowUp'
  };
  let MenuActions = {
    Close: 0,
    CloseSelect: 1,
    First: 2,
    Last: 3,
    Next: 4,
    Open: 5,
    Previous: 6,
    Select: 7,
    Space: 8,
    Type: 9
  };
} // select

function openSettinng(elem) {
  $(elem).find('.settings-drop').slideToggle(); // $(document).mouseup(function (e) {
  //     let div = $(this).closest('.settings-more');
  //     if ((!div.is(e.target) && div.has(e.target).length === 0)) {
  //         $(elem).find('.settings-drop').slideUp();
  //     }
  // });
} //
// function handler(ev) {
//     let target = $(ev.target);
//     if( target.is(".overview-item__block") ) {
//         console.log($(this))
//         console.log('The mouse was over' );
//     }
// }
// $(".overview-item__block").mouseleave(handler);


$('.chat-right').on('click', function () {
  $(this).toggleClass('active');
  let countClickedBlock = 0;
  let countDeactivatedClickedBlock = 0;
  $('.chat-right').each(function () {
    if ($(this).hasClass('active')) {
      countClickedBlock = countClickedBlock + 1;
    }

    if ($(this).hasClass('deactivate') && $(this).hasClass('active')) {
      countDeactivatedClickedBlock = countDeactivatedClickedBlock + 1;
    }
  });

  if ($(this).children('.chat-message-count').length > 0) {
    $(this).children('.chat-message-count').remove();
  } else {
    $("<p/>").text(countClickedBlock).attr('class', 'chat-message-count').appendTo($(this));
  }

  if ($(this).hasClass('deactivate') && $(this).hasClass('active')) {
    $('.chat-right').each(function () {
      if ($(this).hasClass('active')) {
        countClickedBlock = countClickedBlock + 1;
      }
    });
  }

  if (countDeactivatedClickedBlock > 0) {
    $('.chat-right').each(function () {
      if (!$(this).hasClass("deactivate")) {
        $(this).css('pointer-events', 'none');
      }
    });
  }

  if (countClickedBlock > 0) {
    $('.chat__bottom-main').hide();
    $('.chat__bottom-select').show();

    if (!$(this).hasClass("deactivate") && $('.chat-right.active').length == 1) {
      $('.remove-chat').show();
      $('.restore-chat').hide();
    }

    if (countDeactivatedClickedBlock > 0) {
      $('.remove-chat').hide();
      $('.restore-chat').show();
    } else {
      $('.remove-chat').show();
      $('.restore-chat').hide();
    }

    $('.chat__bottom-count').text(countClickedBlock);
    $('.remove-chat').on('click', function () {
      $('.chat-right.active').each(function () {
        $(this).addClass('deactivate');
        $(this).removeClass('active');
        $(this).children('.chat-message-count').remove();
        $('.chat__bottom-count').text("");
        $('.chat__bottom-main').show();
        $('.chat__bottom-select').hide();
        $("<span/>").text('Diese Nachricht wurde gelöscht.').attr('class', 'remove-message-text').prependTo($(this));
        $('.chat-right').css('pointer-events', 'initial');
      });
    });
    $('.restore-chat').on('click', function () {
      $('.chat-right.deactivate.active').each(function () {
        $(this).removeClass('deactivate');
        $(this).removeClass('active');
        $(this).find('.remove-message-text').remove();
        $('.chat__bottom-count').text("");
        $(this).children('.chat-message-count').remove();
        $('.chat__bottom-main').show();
        $('.chat__bottom-select').hide();
        $('.chat-right').css('pointer-events', 'initial');
      });
    });
  } else if (countClickedBlock == 0) {
    $('.chat__bottom-main').show();
    $('.chat__bottom-select').hide();
  }
});
$('.chat__bottom-select-close').on('click', function () {
  $('.chat-right.active').each(function () {
    $(this).removeClass('active');
    $('.chat__bottom-main').show();
    $('.chat__bottom-select').hide();
    $('.chat-right').css('pointer-events', 'initial');
    $(this).children('.chat-message-count').remove();
  });
});
$('.new-communication__bar li').on('click', function () {
  $('.new-communication__bar li').removeClass('active');
  $(this).addClass('active');
  let dataClass = $(this).attr('data-target');
  $('.new-communication-form').hide();
  $('.' + dataClass).show();
});
$(function () {
  let imagesPreview = function imagesPreview(input, placeToInsertImagePreview) {
    if (input.files) {
      let filesAmount = input.files.length;

      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();

        reader.onload = function (event) {
          let container = $('<div>').appendTo(placeToInsertImagePreview);
          container.addClass('chat-right chat-file');
          let textTop = $('<span>').appendTo(container);
          let textBottom = $('<span>').appendTo(container);
          textTop.addClass('chat-file__top');
          textBottom.addClass('chat-file__bottom');
          let text = $('<span>').appendTo(textTop);
          text.text(input.files[0].name);
          let _size = input.files[0].size;
          let fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
            i = 0;

          while (_size > 900) {
            _size /= 1024;
            i++;
          }

          let exactSize = Math.round(_size * 100) / 100 + ' ' + fSExt[i];
          let textSize = $('<span>').appendTo(textTop);
          textSize.text(exactSize);
          let textDowmload = $('<span>').appendTo(textBottom);
          textDowmload.text('Herunterladen');
          textDowmload.attr('onclick', 'downloadFileMessage(this)');
          let timeInMs = new Date().toLocaleTimeString('en-US', {
            hour12: false,
            hour: "numeric",
            minute: "numeric"
          });
          let textTime = $('<span>').appendTo(textBottom);
          textTime.text(timeInMs);
          textTime.addClass('message-time');
        };

        reader.readAsDataURL(input.files[i]);
      }
    }
  };

  $('#load-file-message').on('change', function () {
    imagesPreview(this, '.chat-info');
  });
});
$('.form-toggle input').on('change', function () {
  if ($(this).is(':checked')) {
    $(this).closest('.form-toggle').find('.form-toggle-block').show();
  } else {
    $(this).closest('.form-toggle').find('.form-toggle-block').hide();
  }
});
$('.add-time').on('click', function (e) {
  e.preventDefault(); //disable cut,copy,paste

  $('.input-container-add-time:first-child').clone(true).css('display', 'flex').appendTo('.add-tome-block');
  $(this).closest('.input-container-add-time').addClass('time-added');
});

$(document).ready(function () {
  $(".add-open-services .add-time").click(function () {
    let getValFirst = $("#timeFirst").val();
    let getValSecond = $("#timeSecond").val();
    let container = $('<div>').appendTo('.modal-time');
    container.addClass('modal-time__item');
    let text = $('<span>').appendTo(container);
    text.text(getValFirst + ' - ' + getValSecond);
    let remove = $('<span>').appendTo(container);
    remove.attr('onclick', 'removeTime(this)');
    remove.attr('class', 'remove-time');
  });
});
$('.modal-time__toggle-top li').on('click', function () {
  $('.modal-time__toggle-top li').removeClass('active');
  $(this).addClass('active');
  $('.modal-time__toggle-content').hide();
  $('.' + $(this).attr('data-class')).show();
});


/**
 * This code is stopping event propagation for an event callback function.
 *
 * When an event occurs on an element, it will fire for that element and then bubble up to parent elements. Event propagation refers to this bubbling behavior.
 *
 * The event.stopPropagation() method call prevents the event from bubbling up to parent elements. So in this case, if the cancelShowFiltermenuEvent function is used as an event callback (e.g. onclick), the event will fire for that element but not continue propagating to ancestors in the DOM.
 *
 * This is useful if you want the event handling logic contained just to that element and don't want parent elements' event handlers to also run.
 */
function cancelShowFiltermenuEvent() {
  event.stopPropagation();
}